import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Technology from "@/pages/Technology";
import SolutionsPage from "@/pages/Solutions";
import Security from "@/pages/Security";
import Company from "@/pages/Company";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import TrustCentre from "@/pages/TrustCentre";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to allow the target route to mount.
      const id = hash.slice(1);
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/security" element={<Security />} />
          <Route path="/trust-centre" element={<TrustCentre />} />
          <Route path="/company" element={<Company />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
